
































































































































































































































import {
  ContentsManagerService as contentApi,
  GoogleService,
} from "@/common/api";
import QNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { formatImageUrl, formatVideoUrl, getYoutubeUrl } from "@/common/utils";
import ContentsEdit from "@/components/admin/contents/contentsEditComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import {
  CATEGORIES_ARRAY,
  STATUSES_ARRAY,
  TYPES_ARRAY,
} from "@/model/contentUpload";
import PaginateModel from "@/model/paginate";
import store from "@/store";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { Component, Vue } from "vue-property-decorator";
import ModalComponent from "../utils/modalComponent.vue";
import VideoPlayerComponent from "../utils/videoPlayerComponent.vue";

@Component({
  name: "ContentsListComponent",
  components: {
    QTableHeader,
    QPaginate,
    ContentsEdit,
    QMultiSelect,
    ModalComponent,
    VideoPlayerComponent,
  },
})
export default class ContentsListComponent extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initSearch = {
    categories: ["all"],
    types: ["all"],
    statuses: ["all"],
    name: "",
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};
  public isGoogleAuth = false;
  public youtube = {};
  public hasYoutubeError = false;
  public intervalId = null;

  public initHeaders = [
    { id: "created_at", name: "登録日時", order: "desc" },
    { id: "created_by", name: "登録者", order: "" },
    { id: "category", name: "カテゴリ名" },
    { id: "related", name: "関連データ" },
    { id: "type", name: "形式" },
    { id: "name", name: "ファイル名" },
    { id: "youtube", name: "youtube" },
    { id: "aws", name: "AWS" },
    { id: "", name: "" },
  ];

  public selectedAllCategory = { id: "all", name: "すべてのカテゴリ" };
  public categories = [...[this.selectedAllCategory], ...CATEGORIES_ARRAY];
  public selectedAllType = { id: "all", name: "すべての形式" };
  public types = [...[this.selectedAllType], ...TYPES_ARRAY];
  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public statuses = [...[this.selectedAllStatus], ...STATUSES_ARRAY];

  public headers = [];

  public contents = [];

  public connection: WebSocket;
  public connectionId = null;

  public currentRole = store.state.Auth.admin_user.role.name;

  public mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.checkGoogleAuth();
    // this.categories = this.getCategories();
    this.filterData();
  }
  public created() {
    this.connectSocket();
  }

  public clickSearch() {
    this.searchParams.page = 1;
    this.filterData();
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;

    if (query.types) {
      if (typeof query.types === "string") {
        query.types = [query.types as string];
      } else if (typeof query.types === "object") {
        query.types = query.types as string[];
      }
    }

    if (query.categories) {
      if (typeof query.categories === "string") {
        query.categories = [query.categories as string];
      } else if (typeof query.categories === "object") {
        query.categories = query.categories as string[];
      }
    }

    if (query.statuses) {
      if (typeof query.statuses === "string") {
        query.statuses = [query.statuses as string];
      } else if (typeof query.statuses === "object") {
        query.statuses = query.statuses as string[];
      }
    }

    if (clear) {
      query = {};
    }
    query = {
      ...this.initSearch,
      ...query,
      ...this.searchParams,
      ...addition,
    };
    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.searchParams = query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    const categories = query.categories;
    const statuses = query.statuses;
    const types = query.types;
    if (categories === "all") {
      query.categories = ["all"];
    }
    if (statuses === "all") {
      query.statuses = ["all"];
    }
    if (types === "all") {
      query.types = ["all"];
    }
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    let message: any;
    try {
      const result = await contentApi.adminContents(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.contents = result.data.contents;
      this.contents = this.contents.map((item) => {
        item.image_scale = this.formatAwsUrl(item.name, item.type);
        return item;
      });
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }
  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public editContent() {
    (this.$refs.contentsEdit as ContentsEdit).show();
  }

  public formatAwsUrl(name, type) {
    if (type === "image") {
      return formatImageUrl(name, "745x1048");
    } else {
      return formatVideoUrl(name);
    }
  }

  public getYoutubeUrl(id) {
    return getYoutubeUrl(id);
  }

  public async deleteContent(content) {
    this.$modal.showDelete({
      text: this.$t("common.message.delete_confirm"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await contentApi.adminContentsDelete({
            contentId: content.id,
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.filterData();
        } catch (error) {
          message = error.body.message;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public async linkYoutube() {
    const result = await GoogleService.adminGoogleAuth({});
    if (result.status == "success") {
      window.location.href = result.data.url;
    } else {
      QNotify.error({
        text: result.message,
      });
    }
  }

  public async checkGoogleAuth() {
    const result = await GoogleService.adminGoogleAccessToken({}).catch(() => {
      this.hasYoutubeError = true;
      return { message: "Youtubeとの接続に失敗しました。" } as any;
    });

    if (result.status == "success") {
      this.isGoogleAuth = true;
      this.youtube = result.data;
    } else {
      if (this.hasRole(["admin", "manager"])) {
        QNotify.error({
          text: result.message,
        });
      }
    }
  }

  public async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.log("Failed to copy text:", error);
    }
  }

  public getUrlRelated(content) {
    if (content.show_id) {
      return `/show/edit/${content.show_id}`;
    }
    if (content.livecarp_id) {
      return `/live/edit/${content.livecarp_id}`;
    }
    if (content.event_id) {
      return `/event/edit/${content.event_id}`;
    }
    if (content.item_id) {
      return `/store/edit/${content.item_id}`;
    }
    if (content.carpsale_item_id) {
      return `/carpsale/edit/${content.carpsale_item_id}`;
    }

    return "";
  }

  public getTitleRelated(content) {
    if (content.show_id) {
      return content.show_title;
    }
    if (content.livecarp_id) {
      return content.livecarp_title;
    }
    if (content.event_id) {
      return content.event_title;
    }
    if (content.item_id) {
      return content.item_title;
    }
    if (content.carpsale_item_id) {
      return content.carpsale_title;
    }

    return "";
  }

  public ismovie(content): boolean {
    if (!content || !content.type) {
      return false;
    }

    return content.type === "movie";
  }

  public hasRole(roles: string | string[]) {
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(this.currentRole);
  }

  public async connectSocket() {
    const result = await contentApi.adminContentsConnectSocketUrl({});
    this.connection = new WebSocket(result.data.connect_socket_url);
    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);
      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId &&
        data.event === "Refresh"
      ) {
        this.filterData(false, { disabledLoadinng: true });
      }
    });
    this.connection.addEventListener("open", () => {
      const body: any = {
        action: "subscribe",
        topic: "upload-content/change-status",
      };

      this.connection.send(JSON.stringify(body));
    });
  }
  public beforeDestroy() {
    this.connection.close();
    this.connection = null;
  }

  public async retryUpload(content) {
    const parameters = {
      category: content.container,
      uploadFiles: [
        {
          extension: content.uploadFile.extension,
          filePath: content.uploadFile.filePath,
          filename: content.uploadFile.filename,
          size: content.uploadFile.size,
          mimeType: content.uploadFile.mimeType,
        },
      ],
      livecarpId: content.livecarp_id,
      eventId: content.event_id,
      showId: content.show_id,
      youtubeId: content.youtube_id,
      isConverted: content.is_converted,
      uploadContentId: content.id,
      movieId: content.movie_id,
    };

    try {
      await contentApi.adminContentsRetryCreate(parameters);
      this.filterData(false, { disabledLoadinng: true });
      QNotify.success({
        text: this.$t("common.message.created"),
      });
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
    }
  }

  public handleOpenVideoPlayer(url: string) {
    (this.$refs.popupRef as ModalComponent).open();
    this.$nextTick(() => {
      const slotChild = this.$refs.videoRef as VideoPlayerComponent;
      slotChild.load(url);
    });
  }

  public handleCloseVideoPopup() {
    this.$nextTick(() => {
      const slotChild = this.$refs.videoRef as VideoPlayerComponent;
      slotChild.stop();
    });
  }
}
